/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { DepartmentsControllerFindAllQueryResponse, DepartmentsControllerFindAllQueryParams, DepartmentsControllerFindAll401, DepartmentsControllerFindAll403 } from "../../models/departmentsController/DepartmentsControllerFindAll";

function getDepartmentsControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/departments` as const }  
  return res
}

/**
 * @summary Get all departments
 * {@link /api/v1/departments}
 */
export async function departmentsControllerFindAll(params?: DepartmentsControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DepartmentsControllerFindAllQueryResponse, ResponseErrorConfig<DepartmentsControllerFindAll401 | DepartmentsControllerFindAll403>, unknown>({ method : "GET", url : getDepartmentsControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}